import { render, staticRenderFns } from "./Labours.vue?vue&type=template&id=752a24f0&"
import script from "./Labours.vue?vue&type=script&lang=js&"
export * from "./Labours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports